import { shadeColor } from "../100-ms-integration/common/utils"

export const getThemeData = (color: any, font: any) => {
    return {
        colors: {
          brandDefault: color,
          brandDark: shadeColor(color, -30) as any,
          brandLight: shadeColor(color, 30) as any,
          brandDisabled: shadeColor(color, 10) as any,
            // bgPrimary: shadeColor(color, 10) as any,
            // bgSecondary: shadeColor(color, 10) as any,
            // bgTertiary: shadeColor(color, 10) as any,
            // surfaceLight: shadeColor(color, 10) as any,
            // surfaceLighter: shadeColor(color, 10) as any,
            // textPrimary: shadeColor(color, 10) as any,
            // textSecondary: shadeColor(color, 10) as any,
            // textDisabled: shadeColor(color, 10) as any,
            // textInvert: shadeColor(color, 10) as any,
            // textHighEmp: shadeColor(color, 10) as any,
            // textMedEmp: shadeColor(color, 10) as any,
            // iconBtn: shadeColor(color, 10) as any,
            // iconHoverBg: shadeColor(color, 10) as any,
            // transparentBg: shadeColor(color, 10) as any,
            // mainBg: shadeColor(color, 10) as any,
            // tileBg: shadeColor(color, 10) as any,
            // secondaryDisabled: shadeColor(color, 10) as any,
            // previewBg: shadeColor(color, 10) as any,
            // statsBg: shadeColor(color, 10) as any,
            // menuBg: shadeColor(color, 10) as any,
            // inputBg: shadeColor(color, 10) as any,
            // toastBg: shadeColor(color, 10) as any,
            // borderDefault: shadeColor(color, 10) as any,
            // backgroundDefault: shadeColor(color, 10) as any,
            // borderLighter: shadeColor(color, 10) as any,
            // white: shadeColor(color, 10) as any,
            // black: shadeColor(color, 10) as any,
            // transparent: shadeColor(color, 10) as any,
            // orange: shadeColor(color, 10) as any,
            // cyan: shadeColor(color, 10) as any,
            // tamarind: shadeColor(color, 10) as any,
            // yellow: shadeColor(color, 10) as any,
            // twinYellow: shadeColor(color, 10) as any,
            // green: shadeColor(color, 10) as any,
            // darkgreen: shadeColor(color, 10) as any,
            // purple: shadeColor(color, 10) as any,
            // borderLight: shadeColor(color, 10) as any,
            // borderAccent: shadeColor(color, 10) as any,
            // success: shadeColor(color, 10) as any,
            // error: shadeColor(color, 10) as any,
            // errorTint: shadeColor(color, 10) as any,
            // warning: shadeColor(color, 10) as any,
            // grayLight: shadeColor(color, 10) as any,
            // grayDefault: shadeColor(color, 10) as any,
            // grayDark: shadeColor(color, 10) as any,
            // secondaryGray: shadeColor(color, 10) as any,
            // grayDisabled: shadeColor(color, 10) as any,
            // textAccentHigh: shadeColor(color, 10) as any,
            // textAccentMedium: shadeColor(color, 10) as any,
            // textAccentDisabled: shadeColor(color, 10) as any,
            // surfaceDefault: shadeColor(color, 10) as any,
            // surfaceDark: shadeColor(color, 10) as any,
            // backgroundDark: shadeColor(color, 10) as any,
            // backgroundDarker: shadeColor(color, 10) as any,
            // primaryLight: shadeColor(color, 10) as any,
            // primaryDefault: shadeColor(color, 10) as any,
            // primaryDark: shadeColor(color, 10) as any,
            // primaryDisabled: shadeColor(color, 10) as any,
            // secondaryLight: shadeColor(color, 10) as any,
            // secondaryDefault: shadeColor(color, 10) as any,
            // secondaryDark: shadeColor(color, 10) as any,
            // errorDefault: shadeColor(color, 10) as any,
            // errorLight: shadeColor(color, 10) as any,
            // errorDark: shadeColor(color, 10) as any,
            // errorDisabled: shadeColor(color, 10) as any,
        },
        fonts: {
          sans: font || "sans-serif",
        },
        // shadows: {
        //   sm: shadeColor(color, -30) as any,
        //   md: shadeColor(color, -30) as any,
        // },
        // fontSizes: {
        //   h1: 42 as any,
        //   h2: 32 as any,
        //   h3: 28 as any,
        //   h4: 24 as any,
        //   h5: 20 as any,
        //   h6: 18 as any,
        //   tiny: 14 as any,
        //   xs: 12 as any,
        //   sm: 14 as any,
        //   md: 16 as any,
        //   lg: 24 as any,
        // },
        // fontWeights: {
        //   semiBold: '900' as any,
        //   medium: '700' as any,
        //   regular: '500' as any,
        // },
        // lineHeights: {
        //   h1: 6 as any,
        //   h2: 5 as any,
        //   h3: 4 as any,
        //   h4: 3 as any,
        //   h5: 2 as any,
        //   h6: 2 as any,
        //   tiny: 1 as any,
        //   xs: 0.5 as any,
        //   sm: 1 as any,
        //   md: 2 as any,
        // },
        // radii: {
        //   '0': '' as any,
        //   '1': '' as any,
        //   '2': '' as any,
        //   '3': '' as any,
        //   '4': '' as any,
        //   round: '' as any,
        // },
        // space: {
        //   0: 0 as any,
        //   xs: 1 as any,
        //   sm: 2 as any,
        //   md: 3 as any,
        //   lg: 4 as any,
        //   xl: 6 as any,
        //   px: 1 as any,
        //   1: 1 as any,
        //   2: 2 as any,
        //   3: 3 as any,
        //   4: 4 as any,
        //   5: 5 as any,
        //   6: 6 as any,
        //   7: 7 as any,
        //   8: 8 as any,
        //   9: 9 as any,
        //   10: 10 as any,
        //   11: 11 as any,
        //   12: 12 as any,
        //   13: 14 as any,
        //   14: 14 as any,
        //   15: 15 as any,
        //   16: 16 as any,
        //   17: 17 as any,
        //   18: 18 as any,
        //   19: 19 as any,
        //   20: 20 as any,
        //   24: 24 as any,
        //   28: 28 as any,
        //   32: 32 as any,
        //   36: 36 as any,
        //   40: 60 as any,
        //   44: 44 as any,
        //   48: 48 as any,
        //   52: 53 as any,
        //   56: 56 as any,
        //   60: 60 as any,
        //   64: 64 as any,
        //   72: 72 as any,
        //   80: 80 as any,
        //   96: 96 as any,
        //   100: 100 as any,
        // },
        // borderWidths: {
        //     light: 1 as any,
        //     normal: 2 as any,
        //     bold: 4 as any,
        //     extrabold: 8 as any,
        //     black: 2 as any,
        // },
    } as any
}